<app-navbar [navList]="navList" entityName="Gruppo" [search]="true" [createButton]="hasMadPermission ? 'show' : 'hide'"
    (searchEvent)="searchValue = $event" i18n-searchPlaceholder
    searchPlaceholder="Cerca per Nome, Descrizione..."></app-navbar>
<div class="qai-content-box overflow-auto">
    <app-entity-info [name]="'Gruppi'">
         <p class="text-primary mb-2" *ngxPermissionsOnly="['ROLE_ADM']" i18n>
            I gruppi di utenti servono per organizzare gli accessi alla piattaforma. <br />
            Ogni utente appartiene a uno o più gruppi, e ogni gruppo è collegato a uno o più contesti. <br />
            In questo modo si definisce quali contesti (e relative knowledge base) ogni utente può visualizzare e
            gestire. <br />
            Come utente Admin, puoi accedere e lavorare solo sui contesti associati ai gruppi di cui fai parte.

            <br /><br />
            Se non sei associato ad nessun gruppo, contatta un Master Admin per essere aggiunto a un gruppo e accedere
            ai contesti.
        </p>

        <p class="text-primary mb-2" *ngxPermissionsOnly="['ROLE_MAD']" i18n>
            I gruppi di utenti sono il punto centrale per la gestione degli accessi. <br />
            Gli utenti vengono assegnati ai gruppi, e i gruppi vengono collegati ai contesti. <br />
            In qualità di Master Admin puoi creare e gestire i gruppi, assegnare utenti ai gruppi
            e collegare i gruppi ai contesti. <br />
            In questo modo controlli quali utenti possono accedere e operare sulle knowledge base
            (documenti e siti web) di ciascun contesto.

            <br /><br />
            Per creare un gruppo clicca il pulsante "CREA GRUPPO" in alto a destra.
        </p>
    </app-entity-info>

    @let groups = (groups$ | async) || [];
   
    <app-shared-table [tableHead]="groups.length > 7 ? 'solid' : 'trasparent'" [columns]="groupColumns" [items]="getFilteredGroups(groups)"
        [isLoading]="loading" (multiActionEvent)="$event.action === 'delete' && deleteGroups($event.list);"
        (openDetailEvent)="openGroupDetail($event)"
        (singleActionEvent)="$event.action === 'unlink' && unlinkGroup($event.item)" [multiActions]="multiActions"
        [searchTerm]="searchValue" [tableHeightElems]="7" emptyStateTitle="Nessun gruppo trovato" i18n-emptyStateTitle>
    </app-shared-table>
    
</div>